import { Http, Headers, Response, RequestOptions } from '@angular/http'
import { Observable } from 'rxjs/Rx'

import { AppContext } from './..'
import { ApiError, HttpStatus, ApiErrorFactory } from '../../core/models'
import { AppMetricsService } from '../../core/services'

export class HttpHelper {
  constructor(
    private _http: Http,
    private _appContext: AppContext,
    private _apiErrorFactory: ApiErrorFactory,
    private _httpStatus: HttpStatus,
    private _appVersion: number,
    private _appMetricsService: AppMetricsService,
    private _maxRetryAttempts: number = 4
  ) {}

  public put(uri, data = {}): Observable<any> {
    return this.request('put', uri, data)
  }

  public post(uri, data = {}): Observable<any> {
    return this.request('post', uri, data)
  }

  public get(uri): Observable<any> {
    return this.request('get', uri)
  }

  public delete(uri): Observable<any> {
    return this.request('delete', uri)
  }

  private request(type, uri, data?): Observable<any> {
    const body = JSON.stringify(data)
    const options = new RequestOptions({ headers: this.createSecureHeader(), withCredentials: true })
    const response = data ? this._http[type](uri, body, options) : this._http[type](uri, options)

    this._appMetricsService.logApiRequest(uri, type)

    return response
      .map((res) => {
        if (res.status === this._httpStatus.NO_CONTENT) { return {} }

        const parsedResponse = res.json()
        if (this._httpStatus.CATEGORY.SUCCESS === this._httpStatus.getCategory(res.status)
          || this._httpStatus.CATEGORY.SUCCESS === this._httpStatus.getCategory(parsedResponse.status_code)) {
          return parsedResponse
        }

        throw this._apiErrorFactory.get(type, uri, body, res, parsedResponse)
      })
      .retryWhen((errors) => {
        return Observable.range(1, 4).zip(errors, (attemptNo, error) => [attemptNo, error]).flatMap((sequenceError) => {
          const [attemptNo, error] = sequenceError
          const delayInMs = (attemptNo as number * 2) * 1000

          if (! this.canRetryRquest(error as Response)) {
            throw error
          }

          if (attemptNo === this._maxRetryAttempts ||
              ( error instanceof ApiError
                && this._httpStatus.CATEGORY.CLIENT_ERROR === this._httpStatus.getCategory(+error.status)
              )
          ) {
            throw error
          }
          this._appMetricsService.logApiRetry(uri, type)
          return Observable.timer(delayInMs)
        })
      })
      .catch((error: Response | Error) => {
        this._appMetricsService.logApiError(error)
        error = error instanceof Response ? this._apiErrorFactory.get(type, uri, body, error, error.json()) : error
        return Observable.throw(error)
      })
  }

  private createSecureHeader() {
    const headers = new Headers()
    // TODO [GitHub Issue]: Make this part of the context object
    headers.append('mp-auth-token', this._appContext.apiToken.getRawToken())
    // TODO [GitHub Issue]: Externalize JSONAPI logic into a separate object/class/configuration
    // We might want to configure for instance the JSONAPI backend to add these headers
    headers.append('Content-Type', 'application/vnd.api+json')
    headers.append('Accept', `*/*, application/vnd.api+json; q=1; version=${this._appVersion}`)
    return headers
  }

  private canRetryRquest(response: Response) {
    if (response instanceof Response
      && this._httpStatus.CATEGORY.CLIENT_ERROR === this._httpStatus.getCategory(response.status)) {
      return false
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/http/http-helper.ts